import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EditorPluginAI, NextEditorPluginAI } from '../editor-plugin-ai';
import { createEditorPluginAIProvider } from '../provider/provider';
import { prDescriptionConfigItem } from './config-items-empty/bb-pr-description/bb-pr-description';
import { brainstormConfigItem } from './config-items-empty/brainstorm/brainstorm';
import { generateContentConfigItem } from './config-items-empty/generate-content/generate-content';
import { summarizePageConfigItem } from './config-items-empty/summarize-page/summarize-page';
import { casualTone, educationalTone, empatheticTone, neutralTone, professionalTone } from './config-items-range/change-tone/change-tone';
import { fixSpellingAndGrammar, improveWriting } from './config-items-range/enhance/enhance';
import { generateFromSelectionConfigItem } from './config-items-range/generate-from-selection/generate-from-selection';
import { shortenConfigItem } from './config-items-range/shorten/shorten';
import { summarizeConfigItem } from './config-items-range/summarize/summarize';
import { _getFetchCustomHeaders, deriveProactiveAIConfig } from './utils';

// Bitbucket

/**
 * This is written here as a "wrapper" in order to retain control of
 * the other values passed into the provider, e.g. configItems,
 * etc. - due to the high level of uncertainty, we'll keep this in place until
 * past phase 3.
 *
 * (design ethos: having control/flexibility in the API)
 *
 * Please reference
 * @see https://hello.atlassian.net/wiki/spaces/CONF/pages/2714833063/Gen+AI+in+Editor+EAP2+-+Product-specific+requirements
 * @see https://hello.atlassian.net/wiki/spaces/EDAI/pages/2731933104/Editor+AI+EAP+Part+2+Dev+Documentation+Prebuilt+Providers+Plugin+Presets
 */
export var createBBEditorPluginAIProvider = function createBBEditorPluginAIProvider(props) {
  var _props$disableInterro;
  // Now deprecated - migrate to handleFeedbackSubmission
  var onExperienceEvent = (props === null || props === void 0 ? void 0 : props.onExperienceEvent) || {
    THUMBS_UP: function THUMBS_UP() {},
    THUMBS_DOWN: function THUMBS_DOWN() {},
    REVIEW_STATE_ENTERED: function REVIEW_STATE_ENTERED() {},
    EXPERIENCE_COMPLETE: function EXPERIENCE_COMPLETE() {}
  };
  var prDescription = [];
  if (props.summarisePrDescriptionUrl) {
    prDescription = [prDescriptionConfigItem({
      generativeAIApiUrl: props.summarisePrDescriptionUrl
    })];
  }
  return createEditorPluginAIProvider({
    disableAISelectionToolbar: true,
    emptyConfig: {
      baseGenerate: generateContentConfigItem,
      getSuggestions: function getSuggestions() {
        var emptyConfigItems = [].concat(_toConsumableArray(prDescription), [summarizePageConfigItem, improveWriting, fixSpellingAndGrammar, brainstormConfigItem, shortenConfigItem, professionalTone, empatheticTone, casualTone, neutralTone, educationalTone]);
        return emptyConfigItems;
      }
    },
    rangeConfig: {
      baseGenerate: generateFromSelectionConfigItem,
      getSuggestions: function getSuggestions() {
        return [summarizeConfigItem, improveWriting, fixSpellingAndGrammar, shortenConfigItem, professionalTone, empatheticTone, casualTone, neutralTone, educationalTone];
      }
    },
    generativeAIApiUrl: props.generativeAIApiUrl,
    product: 'BITBUCKET',
    getFetchCustomHeaders: (props === null || props === void 0 ? void 0 : props.getFetchCustomHeaders) || _getFetchCustomHeaders,
    onExperienceEvent: onExperienceEvent,
    handleFeedbackSubmission: props === null || props === void 0 ? void 0 : props.handleFeedbackSubmission,
    AIButtonWrapper: props.AIButtonWrapper,
    proactiveAIToolbarButtonWrapper: props.proactiveAIToolbarButtonWrapper,
    PromptEditor: props.PromptEditor,
    disableInterrogation: (_props$disableInterro = props.disableInterrogation) !== null && _props$disableInterro !== void 0 ? _props$disableInterro : false,
    proactiveAIConfig: _objectSpread(_objectSpread({}, deriveProactiveAIConfig()), props.proactiveAIConfig)
  });
};

/**
 * Intended for use with Bitbucket editors
 *
 */
export var createBBEditorPluginAI = function createBBEditorPluginAI(_ref) {
  var editorPluginAIProvider = _ref.editorPluginAIProvider,
    aiGlobalOptIn = _ref.aiGlobalOptIn;
  var editorPluginAI = new EditorPluginAI({
    editorPluginAIProvider: editorPluginAIProvider,
    aiGlobalOptIn: aiGlobalOptIn
  });
  return {
    editorPluginAI: editorPluginAI,
    nextEditorPluginAI: NextEditorPluginAI
  };
};